var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTransfers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3984 81.5616L72.8473 89.6291L76.4516 93.5555L92 78.8795L76.4516 64.2035L72.8473 68.13L81.3984 76.1975H34.4257C28.2845 76.1975 23.285 71.1231 23.285 64.8901L23.2955 49.7743H18V64.8901C18 74.0841 25.3672 81.5616 34.4257 81.5616H81.3984Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6016 27.4384L37.1527 19.3709L33.5483 15.4444L18 30.1204L33.5483 44.7965L37.1527 40.87L28.6016 32.8025H75.5638C81.7049 32.8025 86.7045 37.8768 86.7045 44.1099V59.2257H92V44.1099C92 34.9159 84.6328 27.4384 75.5743 27.4384H28.6016Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransfers);
export default __webpack_public_path__ + "static/media/icon-transfers.fdbc997e1975d694c27f11cebfca3dc2.svg";
export { ForwardRef as ReactComponent };